export default {
  query: {
    search: '検索',
    duration: '期間',
    to: 'から',
    timezone: 'タイムゾーン',
    range: 'データ範囲',
    day: '日',
    quarter: '四半期',
    month: '月',
    productName: '製品名を検索',
    package: 'パッケージ名を検索',
    creativeName: '素材名を検索',
    dcoId: 'DCOIDを検索',
    dcoVersionName: 'DCOバージョン名を検索',
    combinationId: '組み合わせIDを検索',
    dataDimension: 'データ次元',
    dataIndex: 'データ指標',
    preview: 'プレビュー',
  },
  list: {
    total: '合計',
    product: '製品名',
    package: 'パッケージネーム',
    creativeName: 'クリエイティブ名',
    dcoVersionName: 'DCOバージョン名',
    combinationId: '組み合わせID',
    date: '日付',
    month: '月',
    quarter: '四半期',
    impression: '表示',
    click: 'クリック',
    install: 'インストール',
  },
  button: {
    search: '検索',
    reset: 'リセット',
    unfold: '展開',
    preview: 'プレビュー',
    export: 'データのエクスポート',
  },
}
